import React, { ReactNode } from 'react'

type CardSubTitleProps ={
  subtitle:string | number | ReactNode;
}


export default function CardSubTitle({subtitle}:CardSubTitleProps) {
  return (
    <div>{subtitle}</div>
  )
}
